import React from "react";
import HomePage from "./pages/HomePage";

function App() {
  return <HomePage></HomePage>;
}

export default App;
